// extracted by mini-css-extract-plugin
module.exports = {"postSocialButton":"Share-module--postSocialButton--3z7X0","SocialMediaShareButton":"Share-module--SocialMediaShareButton--2cs8v"};